"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var BreakLabel_styled_exports = {};
__export(BreakLabel_styled_exports, {
  StyledBreakLabel: () => StyledBreakLabel,
  StyledOptionButton: () => StyledOptionButton,
  StyledOptionsList: () => StyledOptionsList,
  StyledPopover: () => StyledPopover
});
module.exports = __toCommonJS(BreakLabel_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_atoms = require("../../atoms");
var import_mixins = require("../../../themes/mixins");
var StyledBreakLabel = import_styled_components.default.button.withConfig({
  displayName: "BreakLabelstyled__StyledBreakLabel",
  componentId: "sc-z4klvs-0"
})(function(_ref) {
  var theme = _ref.theme, darkMode = _ref.darkMode;
  return (0, import_styled_components.css)(["display:flex;align-items:center;justify-content:center;flex-grow:0;width:40px;height:40px;border-radius:20px;background-color:", ";margin:", ";color:", ";border:none;:hover,:focus,:active{background-color:", ";border:1px solid ", ";outline:none;}"], theme.colors.transparent.base, theme.measurements.zero, darkMode ? theme.colors.white : theme.colors.black, darkMode ? theme.colors.black : theme.colors.beige[40], theme.colors.beige[180]);
});
var StyledPopover = (0, import_styled_components.default)(import_atoms.Popover).withConfig({
  displayName: "BreakLabelstyled__StyledPopover",
  componentId: "sc-z4klvs-1"
})(function(_ref2) {
  var theme = _ref2.theme;
  return (0, import_styled_components.css)(["margin:", ";padding:", ";border:1px solid ", ";border-radius:", ";box-shadow:0px 12px 16px rgba(0,0,0,0.1);background-color:", ";z-index:1;"], theme.measurements.zero, theme.measurements.zero, theme.colors.beige[180], theme.measurements.small, theme.colors.white);
});
var StyledOptionsList = import_styled_components.default.ul.withConfig({
  displayName: "BreakLabelstyled__StyledOptionsList",
  componentId: "sc-z4klvs-2"
})(function(_ref3) {
  var theme = _ref3.theme;
  return (0, import_styled_components.css)(["list-style:none;min-width:104px;height:auto;max-height:256px;margin:", ";padding:", ";border:none;overflow-y:auto;", ";"], theme.measurements.zero, theme.measurements.zero, (0, import_mixins.withStyledScrollBar)());
});
var StyledOptionButton = (0, import_styled_components.default)(import_atoms.Button).withConfig({
  displayName: "BreakLabelstyled__StyledOptionButton",
  componentId: "sc-z4klvs-3"
})(function(_ref4) {
  var theme = _ref4.theme;
  return (0, import_styled_components.css)(["box-sizing:border-box;border:1px solid transparent;height:64px;padding:20px 24px;font-family:", ";font-weight:", ";font-size:", ";line-height:24px;border-radius:0px;width:100%;cursor:pointer;:focus{border-color:black;outline:none;box-shadow:none;}"], theme.typography.fonts.primary, theme.typography.weights.regular, theme.typography.sizes.medium);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledBreakLabel,
  StyledOptionButton,
  StyledOptionsList,
  StyledPopover
});
//# sourceMappingURL=BreakLabel.styled.js.map